import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../../utils/Encryption";
import Buttons from "../../../components/ui/button/Buttons";
import FormCreator from "../../../components/Forms/FormCreator";
import { EditGMPCourseData } from "../data/EditGMPCourse.Data";
import { useLazyGetCourseProviderByMemberIdQuery, useLazyGetOtherRepresentativeListQuery, useUpdateGmpCourseProviderMutation } from "../../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import { useLazyGetAllDropDownsForMemberDirectoryQuery, useStoreBase64ImageMutation } from "../../../app/services/common/commonApi";
import SwalAlert from "../../../services/swalService/SwalService";
import { setAllDropDownField, setCourseFieldParameter, setFieldParameter } from "../utils/setFieldParameter";
import ToastService from "../../../services/toastService/ToastService";
import CenterModel from "../../../components/ui/centerModel/CenterModel";
import { APIUrl } from "../../../utils/API/fetchBaseQuery";
import { OtherRepTableConfig } from "../data/OtherRepTableConfig.Data";
import MolGrid from "../../../components/Grid/MolGrid";
import ResetPasswordModel from "./OthersRepresentative/ResetPasswordModel";
import UpdateOtherRepresentative from "./OthersRepresentative/UpdateOtherRepresentative";

const EditCourseProvider = () => {
    const molGridRef = useRef();
    const courseProviderRef = useRef();
    const navigate = useNavigate();
    const { courseId } = useParams();
    const editID = courseId ? decryptAESID(courseId, false) : 0
    const [formData, setFromData] = useState(EditGMPCourseData);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [otherDataSource, setOtherDataSource] = useState()
    const [isPassModal, setIsPassModal] = useState(false);
    const [isUpdateRepresentative, setIsUpdateRepresentative] = useState(false);
    const { success, error } = SwalAlert();
    const [organisationLogo, setOrganisationLogo] = useState(null);
    const [getCourseProviderByMemberId, { isSuccess: isSuccess, isFetching: isFetching, data: getCourseProviderMemberResponse },] = useLazyGetCourseProviderByMemberIdQuery();
    const [getAllDropDowns, { isSuccess: isGetAllDropDownFetched, isFetching: isGetDropDownFetching, data: allDropDownResponse },] = useLazyGetAllDropDownsForMemberDirectoryQuery();
    const [updateGmpCourseProvider, { isSuccess: isSuccessUpdate, isLoading: isFetchingAppUpdate, data: updateGmpCourseProvidertResponse },] = useUpdateGmpCourseProviderMutation();
    const [saveMainImage, { isSuccess: isSuccessImage, isLoading: isLoadingImage, data: profileImageUpload }] = useStoreBase64ImageMutation();
    const [getOtherRepresentativeList, { isLoading: getOtherRepresentativeListLoading, isSuccess: getOtherRepresentativeListSuccess, data: getOtherRepresentativeListData }] = useLazyGetOtherRepresentativeListQuery();
    const [selectedRepresentative, setselectedRepresentative] = useState();

    useEffect( () => {
        const fetchData = async () =>
        {
            await getAllDropDowns();
            if ( courseId )
            {
                getCourseProviderByMemberId( editID );
                getOtherRepresentativeList( editID );
            }
        };
        fetchData();
    }, [ editID ] );

    useEffect(() => {
        if (!isFetching && isSuccess && getCourseProviderMemberResponse) {
            setCourseFieldParameter(getCourseProviderMemberResponse, "getCourseProviderMemberResponse");
        }
    }, [isFetching, isSuccess, getCourseProviderMemberResponse]);

    useEffect(() => {
        if (!getOtherRepresentativeListLoading && getOtherRepresentativeListSuccess && getOtherRepresentativeListData) {
            setOtherDataSource(getOtherRepresentativeListData);
        }
    }, [getOtherRepresentativeListLoading, getOtherRepresentativeListSuccess, getOtherRepresentativeListData]);

    useEffect(() => {
        if (!isGetDropDownFetching && isGetAllDropDownFetched && allDropDownResponse) {
            setAllDropDownField(allDropDownResponse);
        }
    }, [isGetDropDownFetching, isGetAllDropDownFetched, allDropDownResponse]);

    useEffect(() => {
        if (!isFetchingAppUpdate && isSuccessUpdate && updateGmpCourseProvidertResponse) {
            success("GMP Course Provider Updated Successfully ")
            getCourseProviderByMemberId(editID);
        }
    }, [isFetchingAppUpdate, isSuccessUpdate, updateGmpCourseProvidertResponse]);

    useEffect(() => {
        if (!isLoadingImage && isSuccessImage && profileImageUpload) {
            ToastService.success("Image uploaded successfully !")
        }
    }, [isLoadingImage, isSuccessImage, profileImageUpload,]);

    const handleSubmit = () => {
        let gmpCourseProviderData = courseProviderRef.current.getFormData();

        if (!gmpCourseProviderData) {
            error("Please fill all mandatory fields.", "")
            return;
        }

        let request = {
            GMPCourseProviderId: editID,
            IsGovt: gmpCourseProviderData?.organizationfalls === "yes" ? true : false || false,
            OrganisationName: gmpCourseProviderData?.organisationName || null,
            UENNumber: gmpCourseProviderData?.UENNumber || null,
            MailingAddressLine1: gmpCourseProviderData?.mailingAddress1 || null,
            MailingAddressLine2: gmpCourseProviderData?.mailingAddress2 || null,
            CountryId: gmpCourseProviderData?.country?.value || gmpCourseProviderData?.country || null,
            PostalCode: gmpCourseProviderData?.postalCode | null,
            OrganisationWebsite: gmpCourseProviderData?.organisationWebsite || null,
            OrganisationLogo: profileImageUpload?.fileName || getCourseProviderMemberResponse.organisationLogo || null,
            OrganisationLogoName: profileImageUpload?.uploadedFileName || getCourseProviderMemberResponse?.organisationLogoName || null,
            DescriptionOfOrganisation: gmpCourseProviderData?.shortDescriptionofOrganisation || null,
            NameOfRepresentative: gmpCourseProviderData?.nameofRepresentative || null,
            EmailAddress: gmpCourseProviderData?.emailAddress || null,
            ContactNumber: gmpCourseProviderData?.contactNumber || null,
            AlternateNameOfRepresentative: gmpCourseProviderData?.alternateNameOfRepresentative || null,
            AlternateEmailAddress: gmpCourseProviderData?.alternateEmailAddress || null,
            AlternateContactNumber: gmpCourseProviderData?.alternateContactNumber || null
        }
        updateGmpCourseProvider(request);
    }

    const openModal = () => {
        setIsModalOpen(!isModalOpen);
    }

    const handleViewImage = () => {
        setIsModalOpen(true);
    }

    const handleOrganazationImageUpload = async (data) => {
        const { base64Data, fileName: incomingFileName, name } = data;
        const fileName = incomingFileName || name;

        if (!fileName) {
            error("No file name provided", "File Upload Error");
            return;
        }
        const fileExtension = fileName.split('.').pop().toLowerCase();
        if (fileExtension !== "jpg" && fileExtension !== "png" && fileExtension !== "jpeg") {
            error("Only Image files are allowed", "File Upload Error");
            return;
        }

        let saveFileRequest = {
            fileName: fileName,
            fileStr: base64Data,
            storagePath: "GmpCourseProviderLogo",
        }
        const response = await saveMainImage(saveFileRequest)
        setOrganisationLogo(response.data.fileName);
    }

    const handleFormFieldChange = (fieldName, value) => {
        if (fieldName === "organisationLogo" && value) {
            handleOrganazationImageUpload(value);
        }
    };

    const handleBack = () => {
        navigate('/gmpCourseTaskList')
    }
    const formActionHandler = {
        VIEW_IMAGE: handleViewImage,
    }

    const getRepresentativeList =()=>{
        getOtherRepresentativeList(editID);
    }

    const openResetModal = () => {
        setselectedRepresentative();
        setIsPassModal(false);
        setIsUpdateRepresentative(false);

    }

    const resetPassword = (data) => {
        setselectedRepresentative(data);
        setIsPassModal(true);
    }


    const updateRepresentative = (data) => {
        setselectedRepresentative(data);
        setIsUpdateRepresentative(true);
    }
    const actionHandler = {
        RESETPASSWORD: resetPassword,
        EDITINFO: updateRepresentative,
    };
    return (
        <>
            <div className="row form-card">
                {!isGetDropDownFetching &&
                    <FormCreator
                        ref={courseProviderRef}
                        {...formData}
                        onFormFieldValueChange={handleFormFieldChange}
                        onActionChange={formActionHandler}
                    />
                }
            </div>
            {isModalOpen &&
                <CenterModel
                    modelTitle={'View Image'}
                    show={"test"}
                    handleClose={openModal}
                    onUpload={openModal}

                >
                    <div className="image-model">
                        <img
                            src={`${APIUrl}/Common/getImage?type=GmpCourseProviderLogo&fileName=${organisationLogo || getCourseProviderMemberResponse.organisationLogo}`}
                            alt="Uploaded Image"
                        />
                    </div>
                </CenterModel >
            }
            <div className="col-lg-12 mb-4 text-left mt-4 form-title">
                <h4 className="common-subtitle">Others Applicant Representative Details</h4>
            </div>
            <div>
                <MolGrid
                    ref={molGridRef}
                    configuration={OtherRepTableConfig}
                    dataSource={otherDataSource}
                    allowPagination={false}
                    onActionChange={actionHandler}
                />
            </div>
            <div className="col-md-12 mb-4 mt-4 d-flex justify-content-between">
                <Buttons
                    buttonText="Back"
                    buttonTypeClassName="btn black-btn ml-2 mt-4"
                    onClick={handleBack}
                />
                <Buttons
                    buttonText="Save"
                    buttonTypeClassName="btn success-btn ml-2 mt-4"
                    onClick={handleSubmit}
                />
            </div>
            <ResetPasswordModel show={isPassModal} handleClose={openResetModal} selectedRepresentative={selectedRepresentative} />
            <UpdateOtherRepresentative show={isUpdateRepresentative} handleClose={openResetModal} selectedRepresentative={selectedRepresentative}  getRepresentativeList={getRepresentativeList}/>
        </>
    );
};

export default EditCourseProvider;
